import * as Constants from '../constants';

export const getRedemption = ($http, ENV, redemptionId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_REDEMPTION_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/redemptions/${redemptionId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_REDEMPTION_SUCCESS,
          payload: res.data.redemptions,
        });
        resolve(res.data.redemptions);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_REDEMPTION_FAILED, payload: error });
        reject(error);
      });
  });

export const createRedemption = ($http, ENV, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_REDEMPTION_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/redemptions/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_REDEMPTION_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_REDEMPTION_FAILED, payload: error });
        reject(error);
      });
  });

export const updateRedemption = ($http, ENV, redemptionId, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_REDEMPTION_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/redemptions/${redemptionId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_REDEMPTION_SUCCESS, payload: res.data.redemptions });
        resolve(res.data.redemptions);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_REDEMPTION_FAILED, payload: error });
        reject(error);
      });
  });

export const deleteRedemption = ($http, ENV, redemptionId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.DELETE_REDEMPTION_REQUEST });

    $http({
      method: 'DELETE',
      url: ENV.apiEndpoint + `/2.0/redemptions/${redemptionId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.DELETE_REDEMPTION_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.DELETE_REDEMPTION_FAILED, payload: error });
        reject(error);
      });
  });

export const clearRedemption = () => (dispatch) => dispatch({ type: Constants.CLEAR_REDEMPTION });
